module.exports = __webpack_public_path__ + "static/media/brand_block.329fde06.svg";